import React, { useEffect } from 'react';
import actionImg from "../../../assets/images/resource/action.png";
import { Container, Row, Col, Image } from "react-bootstrap";
import AOS from "aos";

const Action = () => {
    useEffect(() => {
        AOS.init({ duration: 2000, },);
    }, [])
    return (
        <>
            <section className='action_wrap'>
                <Container>
                    <Row>
                        <Col sm={12} md={6} lg={6} xl={6}>
                            <div className='action_title' data-aos='fade-down'>
                                <h3>See Oxyzn In Action</h3>
                                <p>Let us your email address if you want to<br /> organise a discovery call.</p>
                            </div>
                            <div className='action_input'>
                                <input type="email" placeholder='Work email' name="email" />
                                <button type='button' className='action_input_btn'>Request Demo</button>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6} xl={6}>
                            <figure className='action_img_wrap' data-aos='fade-down'>
                                <Image src={actionImg} alt="action" fluid />
                            </figure>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Action